import Hero from "@/components/site/Hero";
import EstimateWizard from "@/components/site/EstimateWizard";
import WhyChoose from "@/components/site/WhyChoose";
import Services from "@/components/site/Services";
import Specials from "@/components/site/Specials";
import Pricing from "@/components/site/Pricing";
import Brands from "@/components/site/Brands";
import Projects from "@/components/site/Projects";
import Reviews from "@/components/site/Reviews";
import Membership from "@/components/site/Membership";
import TruckShowcase from "@/components/site/TruckShowcase";
import ContactCTA from "@/components/site/ContactCTA";
import Team from "@/components/site/Team";
import ServiceAreas from "@/components/site/ServiceAreas";
import FAQ from "@/components/site/FAQ";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <EstimateWizard />
      <WhyChoose />
      <Services />
      <Specials />
      <Pricing />
      <Brands />
      <TruckShowcase />
      <Projects />
      <Reviews />
      <Membership />
      <ContactCTA />
      <Team />
      <ServiceAreas />
      <FAQ />
    </main>
  );
}
